import script from "./EmpLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpLayout.vue?vue&type=script&setup=true&lang=ts"

import "./EmpLayout.vue?vue&type=style&index=0&id=3773c947&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3773c947"]])

export default __exports__